<template>
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 28 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.3811 24.7469C10.3811 25.439 9.82257 26 9.13359 26C8.44461 26 7.88609 25.439 7.88609 24.7469C7.88609 24.0548 8.44461 23.4937 9.13359 23.4937C9.82257 23.4937 10.3811 24.0548 10.3811 24.7469Z"
      fill="currentColor"
    />
    <path
      d="M24.1037 24.7469C24.1037 25.439 23.5451 26 22.8561 26C22.1672 26 21.6086 25.439 21.6086 24.7469C21.6086 24.0548 22.1672 23.4937 22.8561 23.4937C23.5451 23.4937 24.1037 24.0548 24.1037 24.7469Z"
      fill="currentColor"
    />
    <path
      d="M1.71094 1H4.20595L7.52431 16.5639C7.64604 17.1339 7.96177 17.6435 8.41716 18.0048C8.87255 18.3662 9.43911 18.5568 10.0193 18.5439H22.2199C22.7878 18.5429 23.3383 18.3475 23.7806 17.9898C24.2229 17.6321 24.5305 17.1335 24.6526 16.5764L26.7109 7.26566H5.54078M10.3811 24.7469C10.3811 25.439 9.82257 26 9.13359 26C8.44461 26 7.88609 25.439 7.88609 24.7469C7.88609 24.0548 8.44461 23.4937 9.13359 23.4937C9.82257 23.4937 10.3811 24.0548 10.3811 24.7469ZM24.1037 24.7469C24.1037 25.439 23.5451 26 22.8561 26C22.1672 26 21.6086 25.439 21.6086 24.7469C21.6086 24.0548 22.1672 23.4937 22.8561 23.4937C23.5451 23.4937 24.1037 24.0548 24.1037 24.7469Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
